import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { toast } from 'sonner';

const Invitation = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const inviteId = searchParams.get("inviteId");

    const responseInvitation = async (response) => {
        loadingShow();
        let postData = {
            inviteId: inviteId,
            inviteResponse: response
        }
        let resp = await postApi(postData, urlApi.responseInvite);
        loadingHide();
        if (resp.responseCode === 200) {
            navigate('/', { replace: true })
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <div className="bg-gray-50 flex items-center justify-center min-h-screen">
            <div className="bg-white shadow-md rounded-lg p-6 max-w-lg w-full">
                <h1 className="text-2xl font-bold text-gray-800 mb-4 text-center">You're Invited!</h1>
                <p className="text-gray-600 text-center mb-6">
                    Hello! You have been invited to join the team. <br /> Please confirm your response below.
                </p>

                <div className="flex items-center justify-center gap-4">
                    <button onClick={() => responseInvitation(1)}
                        className="bg-green-500 text-white py-2 px-6 rounded-lg font-medium hover:bg-green-600 transition duration-200 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2">
                        Accept
                    </button>
                    <button onClick={() => responseInvitation(2)}
                        className="bg-red-500 text-white py-2 px-6 rounded-lg font-medium hover:bg-red-600 transition duration-200 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2">
                        Reject
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Invitation